/* eslint-disable */
/*!
 * jQuery.ScrollTo
 * Copyright (c) 2007-2012 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * Date: 4/09/2012
 *
 * @projectDescription Easy element scrolling using jQuery.
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * @author Ariel Flesler
 * @version 1.4.3.1
 *
 * @id jQuery.scrollTo
 * @id jQuery.fn.scrollTo
 * @param {String, Number, DOMElement, jQuery, Object} target Where to scroll the matched elements.
 *	  The different options for target are:
 *		- A number position (will be applied to all axes).
 *		- A string position ('44', '100px', '+=90', etc ) will be applied to all axes
 *		- A jQuery/DOM element ( logically, child of the element to scroll )
 *		- A string selector, that will be relative to the element to scroll ( 'li:eq(2)', etc )
 *		- A hash { top:x, left:y }, x and y can be any kind of number/string like above.
 *		- A percentage of the container's dimension/s, for example: 50% to go to the middle.
 *		- The string 'max' for go-to-end.
 * @param {Number, Function} duration The OVERALL length of the animation, this argument can be the settings object instead.
 * @param {Object,Function} settings Optional set of settings or the onAfter callback.
 *	 @option {String} axis Which axis must be scrolled, use 'x', 'y', 'xy' or 'yx'.
 *	 @option {Number, Function} duration The OVERALL length of the animation.
 *	 @option {String} easing The easing method for the animation.
 *	 @option {Boolean} margin If true, the margin of the target element will be deducted from the final position.
 *	 @option {Object, Number} offset Add/deduct from the end position. One number for both axes or { top:x, left:y }.
 *	 @option {Object, Number} over Add/deduct the height/width multiplied by 'over', can be { top:x, left:y } when using both axes.
 *	 @option {Boolean} queue If true, and both axis are given, the 2nd axis will only be animated after the first one ends.
 *	 @option {Function} onAfter Function to be called after the scrolling ends.
 *	 @option {Function} onAfterFirst If queuing is activated, this function will be called after the first scrolling ends.
 * @return {jQuery} Returns the same jQuery object, for chaining.
 *
 * @desc Scroll to a fixed position
 * @example $('div').scrollTo( 340 );
 *
 * @desc Scroll relatively to the actual position
 * @example $('div').scrollTo( '+=340px', { axis:'y' } );
 *
 * @desc Scroll using a selector (relative to the scrolled element)
 * @example $('div').scrollTo( 'p.paragraph:eq(2)', 500, { easing:'swing', queue:true, axis:'xy' } );
 *
 * @desc Scroll to a DOM element (same for jQuery object)
 * @example var second_child = document.getElementById('container').firstChild.nextSibling;
 *			$('#container').scrollTo( second_child, { duration:500, axis:'x', onAfter:function(){
 *				alert('scrolled!!');
 *			}});
 *
 * @desc Scroll on both axes, to different values
 * @example $('div').scrollTo( { top: 300, left:'+=200' }, { axis:'xy', offset:-20 } );
 */
import jQuery from 'jquery';
(function ($) {
    /**
     * Copyright (c) 2007 Ariel Flesler - aflesler ○ gmail • com | https://github.com/flesler
     * Licensed under MIT
     * @author Ariel Flesler
     * @version 2.1.2
     */
    (function (f) {
        'use strict';
        'function' === typeof define && define.amd ? define(['jquery'], f) : 'undefined' !== typeof module && module.exports ? (module.exports = f(require('jquery'))) : f(jQuery);
    })(function ($) {
        'use strict';
        function n(a) {
            return !a.nodeName || -1 !== $.inArray(a.nodeName.toLowerCase(), ['iframe', '#document', 'html', 'body']);
        }
        function h(a) {
            return $.isFunction(a) || $.isPlainObject(a) ? a : { top: a, left: a };
        }
        var p = ($.scrollTo = function (a, d, b) {
            return $(window).scrollTo(a, d, b);
        });
        p.defaults = { axis: 'xy', duration: 0, limit: !0 };
        $.fn.scrollTo = function (a, d, b) {
            'object' === typeof d && ((b = d), (d = 0));
            'function' === typeof b && (b = { onAfter: b });
            'max' === a && (a = 9e9);
            b = $.extend({}, p.defaults, b);
            d = d || b.duration;
            var u = b.queue && 1 < b.axis.length;
            u && (d /= 2);
            b.offset = h(b.offset);
            b.over = h(b.over);
            return this.each(function () {
                function k(a) {
                    var k = $.extend({}, b, {
                        queue: !0,
                        duration: d,
                        complete:
                            a &&
                            function () {
                                a.call(q, e, b);
                            },
                    });
                    r.animate(f, k);
                }
                if (null !== a) {
                    var l = n(this),
                        q = l ? this.contentWindow || window : this,
                        r = $(q),
                        e = a,
                        f = {},
                        t;
                    switch (typeof e) {
                        case 'number':
                        case 'string':
                            if (/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)) {
                                e = h(e);
                                break;
                            }
                            e = l ? $(e) : $(e, q);
                        case 'object':
                            if (e.length === 0) return;
                            if (e.is || e.style) t = (e = $(e)).offset();
                    }
                    var v = ($.isFunction(b.offset) && b.offset(q, e)) || b.offset;
                    $.each(b.axis.split(''), function (a, c) {
                        var d = 'x' === c ? 'Left' : 'Top',
                            m = d.toLowerCase(),
                            g = 'scroll' + d,
                            h = r[g](),
                            n = p.max(q, c);
                        t
                            ? ((f[g] = t[m] + (l ? 0 : h - r.offset()[m])),
                              b.margin && ((f[g] -= parseInt(e.css('margin' + d), 10) || 0), (f[g] -= parseInt(e.css('border' + d + 'Width'), 10) || 0)),
                              (f[g] += v[m] || 0),
                              b.over[m] && (f[g] += e['x' === c ? 'width' : 'height']() * b.over[m]))
                            : ((d = e[m]), (f[g] = d.slice && '%' === d.slice(-1) ? (parseFloat(d) / 100) * n : d));
                        b.limit && /^\d+$/.test(f[g]) && (f[g] = 0 >= f[g] ? 0 : Math.min(f[g], n));
                        !a && 1 < b.axis.length && (h === f[g] ? (f = {}) : u && (k(b.onAfterFirst), (f = {})));
                    });
                    k(b.onAfter);
                }
            });
        };
        p.max = function (a, d) {
            var b = 'x' === d ? 'Width' : 'Height',
                h = 'scroll' + b;
            if (!n(a)) return a[h] - $(a)[b.toLowerCase()]();
            var b = 'client' + b,
                k = a.ownerDocument || a.document,
                l = k.documentElement,
                k = k.body;
            return Math.max(l[h], k[h]) - Math.min(l[b], k[b]);
        };
        $.Tween.propHooks.scrollLeft = $.Tween.propHooks.scrollTop = {
            get: function (a) {
                return $(a.elem)[a.prop]();
            },
            set: function (a) {
                var d = this.get(a);
                if (a.options.interrupt && a._last && a._last !== d) return $(a.elem).stop();
                var b = Math.round(a.now);
                d !== b && ($(a.elem)[a.prop](b), (a._last = this.get(a)));
            },
        };
        return p;
    });
})(jQuery);
